import React, { Component } from 'react'
import moment from 'moment'
import 'moment/locale/pt-br'
// import queryString from 'query-string'
import { Row, Col } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import { connect } from 'react-redux'
import { func, object } from 'prop-types'

// actions
import {
  updateStartDate,
  updateEndDate,
  updateTimeframe,
  updateTimeframeWithDateRange,
  changeTimeframeType,
  updateTimeframeButtons
} from '../actions/timeframe'

class TimeframeChooser extends Component {
  constructor (props) {
    super(props)

    // Load via URL params
    // moment.locale('pt-BR')
    // let parsedQuery = queryString.parse(props.location.search)
    // let startDate, endDate, timeFrameStartDate, timeFrameEndDate

    // if (parsedQuery.start_date) {
    //   let formatedStartDate = parsedQuery.start_date.split('-')
    //   formatedStartDate = [formatedStartDate[2], formatedStartDate[1], formatedStartDate[0]].join('-')
    //   startDate = moment(formatedStartDate)
    //   timeFrameStartDate = moment(formatedStartDate).format('YYYY-MM-DD') + 'T00:00:00.000-03:00'
    // } else {
    //   startDate = moment().subtract(8, 'days')
    //   timeFrameStartDate = moment().subtract(8, 'days').format('YYYY-MM-DD') + 'T00:00:00.000-03:00'
    // }

    // if (parsedQuery.end_date) {
    //   let formatedEndDate = parsedQuery.end_date.split('-')
    //   formatedEndDate = [formatedEndDate[2], formatedEndDate[1], formatedEndDate[0]].join('-')
    //   endDate = moment(formatedEndDate)
    //   timeFrameEndDate = moment(formatedEndDate).format('YYYY-MM-DD') + 'T23:59:59.000-03:00'
    // } else {
    //   endDate = moment().subtract(1, 'days')
    //   timeFrameEndDate = moment().subtract(1, 'days').format('YYYY-MM-DD') + 'T23:59:59.000-03:00'
    // }

    // startDate = moment().subtract(8, 'days')
    // timeFrameStartDate = moment().subtract(8, 'days').format('YYYY-MM-DD') + 'T00:00:00.000-03:00'
    // endDate = moment().subtract(1, 'days')
    // timeFrameEndDate = moment().subtract(1, 'days').format('YYYY-MM-DD') + 'T23:59:59.000-03:00'

    this.state = {
      needRefresh: false
    }

    this.handleChangeStartDate = this.handleChangeStartDate.bind(this)
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this)
    this.updateTimeframe = this.updateTimeframe.bind(this)
    this.changeTimeframeType = this.changeTimeframeType.bind(this)
    this.setDateRange = this.setDateRange.bind(this)
    this.updateTimeframeButtons = this.updateTimeframeButtons.bind(this)
  }
  handleChangeStartDate (date) {
    const { updateStartDate } = this.props
    updateStartDate(date)
    this.setState({
      needRefresh: true
    })
  }
  handleChangeEndDate (date) {
    const { updateEndDate } = this.props
    updateEndDate(date)
    this.setState({
      needRefresh: true
    })
  }
  updateTimeframe () {
    const { updateTimeframe } = this.props
    updateTimeframe()
    this.setState({
      needRefresh: false
    })
  }
  changeTimeframeType () {
    const { timeframechooser, changeTimeframeType } = this.props
    let type
    if (timeframechooser.timeframeType === 'regular') {
      type = 'buttons'
    } else {
      type = 'regular'
    }
    changeTimeframeType(type)
  }
  setDateRange (num) {
    const { updateTimeframeWithDateRange, campaign } = this.props
    let startDate, endDate
    if (num > 0) {
      startDate = moment().subtract(num + 1, 'days')
      endDate = moment().subtract(1, 'days')
    } else if (num === 0) {
      startDate = moment()
      endDate = moment()
    } else {
      startDate = moment(campaign.videos[0].created_at.split('T')[0])
      endDate = moment().subtract(1, 'days')
    }
    this.updateTimeframeButtons(num)
    updateTimeframeWithDateRange(startDate, endDate)
  }
  updateTimeframeButtons (num) {
    const { updateTimeframeButtons } = this.props
    switch (num) {
      case 0:
        updateTimeframeButtons({
          today: true,
          sevenDays: false,
          fifteendays: false,
          thirtyDays: false,
          beginning: false
        })
        break
      case 7:
        updateTimeframeButtons({
          today: false,
          sevenDays: true,
          fifteendays: false,
          thirtyDays: false,
          beginning: false
        })
        break
      case 15:
        updateTimeframeButtons({
          today: false,
          sevenDays: false,
          fifteendays: true,
          thirtyDays: false,
          beginning: false
        })
        break
      case 30:
        updateTimeframeButtons({
          today: false,
          sevenDays: false,
          fifteendays: false,
          thirtyDays: true,
          beginning: false
        })
        break
      case -1:
        updateTimeframeButtons({
          today: false,
          sevenDays: false,
          fifteendays: false,
          thirtyDays: false,
          beginning: true
        })
        break
      default:
        break
    }
  }
  render () {
    const { timeframechooser } = this.props
    return (
        <Row className="datepicker-wrapper">
          <Col md={4}>
            <label>Data Inicial</label>
            <DatePicker
              className='form-control'
              dateFormat='DD/MM/YYYY'
              selected={moment(timeframechooser.startDate)}
              onChange={this.handleChangeStartDate}
            />
          </Col>
          <Col md={4}>
            <label>Data Final</label>
            <DatePicker
              className='form-control'
              dateFormat='DD/MM/YYYY'
              selected={moment(timeframechooser.endDate)}
              onChange={this.handleChangeEndDate}
            />
          </Col>
          <Col md={2}>
            <a
              className='btn btn-primary mt26'
              onClick={this.updateTimeframe}
            >
              Atualizar{this.state.needRefresh ? '*' : ''}
            </a>
          </Col>
          {/* <Col md={2}>
            <button className='btn btn-info mt26' onClick={this.changeTimeframeType}>
              <Glyphicon glyph='calendar' />
            </button>
          </Col> */}
        {/* <Row className={timeframechooser.timeframeType === 'buttons' ? '' : 'hidden'}>
          <Col md={10} className='mt26 text-right'>
            <button className={timeframechooser.timeframeButtons.today ? 'btn btn-primary active' : 'btn btn-primary'} onClick={() => { this.setDateRange(0) }}>Hoje</button>
            <button className={timeframechooser.timeframeButtons.sevenDays ? 'btn btn-primary active' : 'btn btn-primary'} onClick={() => { this.setDateRange(7) }}>7 dias</button>
            <button className={timeframechooser.timeframeButtons.fifteendays ? 'btn btn-primary active' : 'btn btn-primary'} onClick={() => { this.setDateRange(15) }}>15 dias</button>
            <button className={timeframechooser.timeframeButtons.thirtyDays ? 'btn btn-primary active' : 'btn btn-primary'} onClick={() => { this.setDateRange(30) }}>30 dias</button>
            {campaign &&
              <button className={timeframechooser.timeframeButtons.beginning ? 'btn btn-primary active' : 'btn btn-primary'} onClick={() => { this.setDateRange(-1) }}>Começo</button>
            }
          </Col>
          <Col md={2}>
            <button className='btn btn-info mt26' onClick={this.changeTimeframeType}>
              <Glyphicon glyph='calendar' />
            </button>
          </Col>
        </Row> */}
        </Row>
    )
  }
}

TimeframeChooser.propTypes = {
  updateStartDate: func,
  updateEndDate: func,
  updateTimeframe: func,
  updateTimeframeWithDateRange: func,
  changeTimeframeType: func,
  updateTimeframeButtons: func,
  timeframechooser: object,
  campaign: object
}

const mapStateToProps = (state) => {
  return {
    timeframechooser: state.timeframechooser
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateStartDate: (date) => {
    dispatch(updateStartDate(date))
  },
  updateEndDate: (date) => {
    dispatch(updateEndDate(date))
  },
  updateTimeframe: () => {
    dispatch(updateTimeframe())
  },
  changeTimeframeType: (type) => {
    dispatch(changeTimeframeType(type))
  },
  updateTimeframeWithDateRange: (startDate, endDate) => {
    dispatch(updateTimeframeWithDateRange(startDate, endDate))
  },
  updateTimeframeButtons: (timeframeButtons) => {
    dispatch(updateTimeframeButtons(timeframeButtons))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(TimeframeChooser)



// WEBPACK FOOTER //
// ./src/components/TimeframeChooser.js